// extracted by mini-css-extract-plugin
module.exports = {"tabsRoot":"Tabs_tabsRoot__DfbXJ","tabButton":"Tabs_tabButton__EixNM","selected":"Tabs_selected__7m8GO","badge":"Tabs_badge__I7YNo","icon":"Tabs_icon__Tgfwz"};